import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { KmsTypePresenter } from "@kaltura/mediaspace-shared-types";
import { MediaMetadataGridContainer, MediaMetadataGridItem } from "../grid/MediaMetadataGrid";
import { EventPresenterWithModal } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { Presenter } from "../../presenter/Presenter";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface MetadataPresentersProps {
    id: string;
    presenters: KmsTypePresenter[];
}

const staticClassBase = "kms-ds-media-page-metadata-presenters";

const StyledPresenters = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

/**
 * media page metadata presenters
 */
export const MetadataPresenters = (props: MetadataPresentersProps) => {
    const { id, presenters } = { ...props };

    const context = useConfig();
    const showPresenterModal = context.eventPlatform.eventListItem.showPresenterModal;
    const isPresenterClickable = context.eventPlatform.eventListItem.isPresenterClickable ?? true;

    return (
        <StyledPresenters className={staticClassBase} id={id} aria-label={translate("all speakers")} role={"region"}>
            <MediaMetadataGridContainer rowSpacing={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 2 }}>
                {presenters.map((presenter: KmsTypePresenter) => {
                    return (
                        <MediaMetadataGridItem key={"presenter" + presenter.id}>
                            <EventPresenterWithModal
                                className={`${staticClassBase}-presenter`}
                                showPresenterModal={showPresenterModal && isPresenterClickable}
                                presenter={presenter}
                            >
                                <Presenter
                                    data={presenter}
                                    showLink={!showPresenterModal && isPresenterClickable}
                                    showPresenterModal={!showPresenterModal && isPresenterClickable}
                                />
                            </EventPresenterWithModal>
                        </MediaMetadataGridItem>
                    );
                })}
            </MediaMetadataGridContainer>
        </StyledPresenters>
    );
};

export default MetadataPresenters;
